export function makeDebouncedStorage(base = localStorage, wait = 500) {
  const timers = new Map()
  const pending = new Map()

  const flush = key => {
    if (!pending.has(key)) return
    base.setItem(key, pending.get(key))
    pending.delete(key)
    clearTimeout(timers.get(key))
    timers.delete(key)
  }
  const flushAll = () => {
    for (const k of [...pending.keys()]) flush(k)
  }
  window.addEventListener('beforeunload', flushAll)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flushAll()
  })

  return {
    getItem(key) {
      return pending.has(key) ? pending.get(key) : base.getItem(key)
    },
    setItem(key, value) {
      pending.set(key, value)
      clearTimeout(timers.get(key))
      timers.set(
        key,
        setTimeout(() => flush(key), wait)
      )
    },
    removeItem(key) {
      pending.delete(key)
      clearTimeout(timers.get(key))
      timers.delete(key)
      base.removeItem(key)
    },
  }
}
